import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { Container, Select } from 'semantic-ui-react';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import { getActiveLanguage } from '../../helpers/homepageUrl';
import { getContentSlug } from '../../helpers/api';
import { useEspecialitatsSelectOptions } from '../../helpers/useEspecialitatsSelectOptions';
import { resolveRichTextHtml } from '../../helpers/richTextHtml';
import QuadreMedicEmbed from '../QuadreMedic/QuadreMedicEmbed';
import MoreInfoBar from '../MoreInfoBar/MoreInfoBar';

const messages = defineMessages({
  selectHeading: {
    id: 'Especialitats select heading',
    defaultMessage: 'CONSULTA EL LLISTAT',
  },
  selectHelp: {
    id: 'Especialitats select help',
    defaultMessage:
      'Feu clic per obtenir informació sobre cadascuna d’elles i els metges de cada especialitat.',
  },
});

const EspecialitatsItemView = ({ content }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const intl = useIntl();
  const locale = useSelector((state) => state.intl.locale);
  const language = getActiveLanguage(pathname, locale);
  const options = useEspecialitatsSelectOptions(language);
  const contentSlug = getContentSlug(content);

  const parentRoute = pathname.split(contentSlug)[0];

  const handleChange = (_event, { value }) => {
    if (value && value !== contentSlug) {
      history.push(`${parentRoute}${value}`);
    }
  };

  return (
    <>
      <Helmet>
        <title>{content.title}</title>
        {content.description ? (
          <meta name="description" content={content.description} />
        ) : null}
        {content['@id'] ? (
          <link rel="canonical" href={flattenToAppURL(content['@id'])} />
        ) : null}
      </Helmet>
      <div className="especialitats-others-links">
        <Container>
          <h3 id="especialitats-others-links-heading">
            {intl.formatMessage(messages.selectHeading)}
          </h3>
          <div className="especialitats-others-links-row">
            <p>{intl.formatMessage(messages.selectHelp)}</p>
            <Select
              value={contentSlug}
              options={options}
              onChange={handleChange}
              aria-labelledby="especialitats-others-links-heading"
            />
          </div>
        </Container>
      </div>

      <Container className="especialitats-item">
        <h1 className="csj-heading1">{content.title}</h1>
        {content.description ? (
          <p className="documentDescription">{content.description}</p>
        ) : null}
        {content.text?.data ? (
          <div
            className="documentText"
            dangerouslySetInnerHTML={{
              __html: resolveRichTextHtml(content.text.data),
            }}
          />
        ) : null}
      </Container>

      <QuadreMedicEmbed language={language} especialitat={content.title} />
      <MoreInfoBar />
    </>
  );
};

EspecialitatsItemView.propTypes = {
  content: PropTypes.shape({
    '@id': PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
    parent: PropTypes.shape({
      '@id': PropTypes.string,
    }),
  }).isRequired,
};

export default EspecialitatsItemView;
